export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: '任务概要',
    field: 'tskInfoNo',
    headerAlign: 'left',
    align: 'left',
    width: 250,
    slots: { default: 'tskInfoNo' },
  },
  {
    title: that.$l('table_label_taskByName') || '经办人',
    field: 'tskByName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'tskByName' },
  },
  {
    title: that.$l('table_label_report_name') || '报告人',
    field: 'createByName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_tskEndDate') || '到期日期',
    field: 'tskEndDate',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.create_date') || '创建时间',
    field: 'createDate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_taskUpdateTime') || '更新时间',
    field: 'modifyDate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
]
